const STORAGE_KEY = 'podcast_progress'

type ProgressMap = Record<string, number>

const getStoredProgress = (): ProgressMap => {
  const raw = localStorage.getItem(STORAGE_KEY)
  try {
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export const getProgressForEpisode = (episodeId: string): number => {
  const progress = getStoredProgress()
  return progress[episodeId] || 0
}

export const saveProgressForEpisode = (episodeId: string, seconds: number) => {
  const raw = localStorage.getItem('podcast_progress')
  const progress = raw ? JSON.parse(raw) : {}

  progress[episodeId] = seconds
  localStorage.setItem('podcast_progress', JSON.stringify(progress))

  window.dispatchEvent(
    new StorageEvent('storage', {
      key: 'podcast_progress',
      newValue: JSON.stringify(progress),
    }),
  )
}
